import { ActionsTypes } from './model'

export const socketConnecting = (socket?: any) => ({ type: ActionsTypes.SOCKET_CONNECTING, socket })

export const socketConnected = () => ({ type: ActionsTypes.SOCKET_CONNECTED })

export const socketConnectionError = () => ({ type: ActionsTypes.SOCKET_CONNECTION_ERROR })
